import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import trainingProgramsActionCreators from '../../store/training-programs/action-creators';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import TrainingProgramDetail from './TrainingProgramDetail';
import TrainingProgramIndex from './TrainingProgramIndex';

class TrainingProgramContainer extends Component {
  // ----------------------
  // Lifecycle
  // ----------------------

  componentWillMount() {
    this.props.fetchTrainingPrograms();
  }

  componentWillUnmount() {
    // this.props.unmountUserContainer();
  }

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        {this.props.userContext.hasScope(['admin']) ? (
          <div>
            <Route component={TrainingProgramIndex} exact path="/admin/training-programs" />
            <Route component={TrainingProgramDetail} path="/admin/training-programs/:trainingProgramGuid" />
          </div>
        ): (
          <div>
            <Route component={TrainingProgramIndex} exact path="/training-programs" />
            <Route component={TrainingProgramDetail} path="/training-programs/:trainingProgramGuid" />
          </div>
        )}
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isLoading: !!state.trainingPrograms.isLoading.length,
    trainingPrograms: state.trainingPrograms.list,
    userContext: state.common.userContext
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTrainingPrograms: () => {
      return dispatch(trainingProgramsActionCreators.fetchTrainingPrograms());
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TrainingProgramContainer));
